import './styles/master.scss';
import '@yzfe/svgicon/lib/svgicon.css';
import 'intersection-observer';
import { createSanitizedSentryPiniaPlugin, initSentry } from '@utils/sentry';
import AnimationRevealDirective from './directives/reveal';
import App from './App.vue';
import ClickAwayDirective from './directives/click-away';
import { createApp } from 'vue';
import { createHead } from '@unhead/vue';
import { createPinia } from 'pinia';
import { initDatadog } from '@utils/datadog';
import { initializeMixpanel } from '@utils/analytics';
import { initMobileWebview } from '@utils/client';
import LazyLoadDirective from './directives/lazy-src';
import { registerBaseComponents } from '@components/_globals';
import { Router } from 'vue-router';
import routerPromise from '@router';
import { vMaska } from 'maska/vue';
import { VueSvgIconPlugin } from '@yzfe/vue-svgicon';

/*eslint-disable @typescript-eslint/no-explicit-any */
declare global {
	interface Window {
		AppleID: any;
		AwsWafCaptcha: any;
		AwsWafIntegration: any;
		awsWafCookieDomainList: string[];
		Persona: any;
		Intercom: any;
		Calendly: any;
		dataLayer: any;
		fbq: any;
		ga: any;
		google: any;
		gtag: any;
		hj: any;
		letterpress: any;
		pdst: any;
		prerenderReady: boolean;
		twttr: any;
		uetq: any;
		Plaid: any;
		initMap: any;
		SENTRY_RELEASE: { id: string }; // auto-injected by Sentry webpack plugin
	}
}
/*eslint-enable @typescript-eslint/no-explicit-any */

const app = createApp(App);

registerBaseComponents({ app });

const head = createHead();
app.use(head);

app.use(VueSvgIconPlugin, {
	tagName: 'SvgIcon',
	isOriginalDefault: true
});

app.directive('reveal', AnimationRevealDirective);
app.directive('lazy', LazyLoadDirective);
app.directive('click-away', ClickAwayDirective);
app.directive('maska', vMaska);

const pinia = createPinia();
pinia.use(createSanitizedSentryPiniaPlugin());
app.use(pinia);

// Must init these before route guards for proper tracking.
initSentry(app);
initMobileWebview();
initializeMixpanel();

routerPromise
	.then((router: Router) => {
		app.use(router);
		router
			.isReady()
			.then(() => {
				app.mount('#app');
			})
			.catch(() => {})
			.finally(() => {
				initDatadog();
			});
	})
	.catch(() => {});
